/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TasksControllerFindAllQueryResponse, TasksControllerFindAllQueryParams, TasksControllerFindAll401, TasksControllerFindAll403 } from "../../models/tasksController/TasksControllerFindAll";

function getTasksControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/tasks` as const }  
  return res
}

/**
 * @summary List tasks (filtered by scope visibility)
 * {@link /api/v1/tasks}
 */
export async function tasksControllerFindAll(params?: TasksControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TasksControllerFindAllQueryResponse, ResponseErrorConfig<TasksControllerFindAll401 | TasksControllerFindAll403>, unknown>({ method : "GET", url : getTasksControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}